const smoothScroll = function(){

    const _init = () => {
        const buttons = document.querySelectorAll('[data-function="smooth-scroll"]');

        [].map.call(buttons, (button) => {
            button.addEventListener('click', handleClick, false);
        });

    };

    const handleClick = (e, el) => {
        const target = document.getElementById(e.target.dataset.target);
        const offset = getOffset(target);

        window.scroll({ top: offset, left: 0, behavior: 'smooth' });
    };

    const getOffset = (el) => {
        const bodyRect = document.body.getBoundingClientRect();
        const elemRect = el.getBoundingClientRect();
        
        return elemRect.top - bodyRect.top;
    };

    
    return {
        init: _init
    }
}();

if(document.querySelectorAll('[data-function="smooth-scroll"]').length ? smoothScroll.init() : '' );